export const providers = {
  directory: {
    title: 'All Providers',
    addProvider: 'Add Provider',
    editProvider: 'Edit Provider',
    searchPlaceholder: 'Search Provider by First Name, Last Name, NPI',
    lookupSubtitle:
      'Lookup providers by first name, last name, or NPI number. You may enter the first few letters of the first and last names (in either lowercase or uppercase).',
    requiredFieldMessage: 'First Name or Last Name is required',
    noRecordsFoundMessage: 'No Records Found',
    fetchProvidersErrorMessage: 'Unable to retrieve providers',
    loadProvidersErrorMessage: 'Something went wrong, could not load Providers.'
  },
  columns: {
    firstName: 'First Name',
    lastName: 'Last Name',
    npiNumber: 'NPI Number',
    email: 'Email',
    phone: 'Phone',
    fax: 'Fax',
    actions: 'Actions'
  },
  form: {
    phoneNumber: 'Phone Number',
    title: 'Title',
    addFailureMessage: (message: string) => `Failed to add Provider: ${message}`,
    addFailureFallback: 'Something went wrong',
    addSuccessMessage: 'Successfully Added Provider',
    updateErrorMessage: 'Unable to update provider',
    updateSuccessMessage: 'Successfully Updated Provider'
  },
  availability: {
    pageTitle: 'Unavailability Schedule',
    addBlock: 'Add Block',
    modeLabel: 'Mode: ',
    addBlockDialogTitle: 'Add Availability Block',
    updateBlockDialogTitle: 'Update Availability Block',
    deleteBlockDialogTitle: 'Delete Availability Block',
    deleteBlockConfirmMessage: 'Are you sure you want to delete this availability block?',
    deleteSuccessMessage: 'Availability block deleted successfully',
    deleteErrorFallback: 'Failed to delete availability block',
    deleteErrorMessage: 'An error occurred while deleting availability block',
    blocksChipHintPrefix: "Click a row's ",
    blocksChipHintLabel: 'Blocks',
    blocksChipHintSuffix: 'chip or the expand arrow to view and manage individual blocks.',
    blockedTimeLabel: (start: string, end: string) => `Blocked Time: ${start} - ${end}`,
    columns: {
      date: 'Date',
      availableWindows: 'Available Windows',
      reasons: 'Reason(s)',
      type: 'Type',
      blocks: 'Blocks'
    },
    typeGlobal: 'Global',
    typeLocal: 'Local',
    form: {
      dateRequired: 'Date is required',
      timezoneRequired: 'Timezone is required',
      reasonRequired: 'Reason is required',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      unavailableDate: 'Unavailable Date',
      timezone: 'Timezone',
      reason: 'Reason',
      startTime: 'Start Time',
      endTime: 'End Time',
      allCompaniesGlobal: 'All Pharmacies (Global)',
      availableTimeRanges: 'Available Time Ranges',
      timeRangesHint: 'These time ranges indicate when the provider is available.',
      addTimeRange: 'Add Time Range',
      addSuccessMessage: 'Availability block created successfully',
      addErrorFallback: 'Failed to create availability block',
      addErrorMessage: 'An error occurred while creating availability block',
      updateSuccessMessage: 'Availability block updated successfully',
      updateErrorFallback: 'Failed to update availability block',
      updateErrorMessage: 'An error occurred while updating availability block'
    }
  }
} as const;
